export default __webpack_public_path__ + "static/banner_cms-c38a442bbded5ce1c427d39e4248b5d4.webp";